import { useParams } from 'react-router'
import { LittleModalCreateEdit } from '../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { SupplierContactPersonModelType } from '@teinor/erp/types/company/supplier/supplierContactPerson'

interface  ModalCreateEditCreditorContactPersonProps extends ModalEditComponentProps {}

const ModalCreateEditCreditorContactPerson: React.FC<ModalCreateEditCreditorContactPersonProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { id } = useParams()
    const { t } = useTwinTranslation()
    const fields: FormRender<SupplierContactPersonModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'position',
                    label: t('position', 'Cargo'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
                {
                    name: 'SupplierId',
                    component: 'InputHidden',
                    value: id
                },
            ],
        },
        {
            cols: 1,
            title: t('contatInformation', 'Información de contacto'),
            elements: [
                {
                    name: 'phone',
                    label: t('phone', 'Teléfono'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'mobile',
                    label: t('mobile', 'Móvil'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'email',
                    label: t('email', 'Email'),
                    component: 'InputWithLabelMargin',
                    type: 'email',
                },
            ]
        }
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/supplier/supplierContactPerson/updateSupplierContactPerson'} translations={{ title: t('editContactPerson', 'Editar Persona de contacto'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (<LittleModalCreateEdit fields={fields} url={'/api/app/supplier/supplierContactPerson/createSupplierContactPerson'} translations={{
        title: t('createContactPerson', 'Crear Persona de contacto'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

export default ModalCreateEditCreditorContactPerson